__webpack_require__.p = "https://candidate-react-staging.staffshift.com/";